/* Matraws mega-nav — interaktioner.
   Åbner på hover (med intent-delay) og klik; lukker på Esc, klik udenfor,
   scroll og mouseleave. Panelet positioneres fixed under headeren. */
(function () {
  if (window.__mtwMegaNav) return;
  window.__mtwMegaNav = 1;

  var OPEN_DELAY = 60, CLOSE_DELAY = 170;

  function init() {
    var nav = document.querySelector('[data-mtw-mn]');
    if (!nav) return;

    var items = [];
    var current = null;
    var timer = null;

    // Glidende gul markør bag topbar-punkterne
    nav.classList.add('mtw-mn--js');
    var slider = document.createElement('span');
    slider.className = 'mtw-mn-slider';
    slider.setAttribute('aria-hidden', 'true');
    nav.insertBefore(slider, nav.firstChild);

    function moveSlider(el) {
      var fresh = !slider.classList.contains('is-on');
      if (fresh) slider.style.transition = 'none';
      slider.style.left = el.offsetLeft + 'px';
      slider.style.top = el.offsetTop + 'px';
      slider.style.width = el.offsetWidth + 'px';
      slider.style.height = el.offsetHeight + 'px';
      if (fresh) {
        void slider.offsetWidth;   // reflow, så første placering ikke animerer
        slider.style.transition = '';
      }
      slider.classList.add('is-on');
    }
    function hideSlider() { slider.classList.remove('is-on'); }

    nav.querySelectorAll('.mtw-mn-plain:not(.mtw-mn-cta):not(.mtw-mn-noslide)').forEach(function (a) {
      a.addEventListener('mouseenter', function () { if (!current) moveSlider(a); });
    });
    nav.addEventListener('mouseleave', hideSlider);

    function headerBottom() {
      var h = document.querySelector('.main-header') || nav.closest('header') || nav;
      var r = h.getBoundingClientRect();
      return Math.max(0, Math.round(r.bottom));
    }

    var GAP = 0;   // flush — panelet forbindes sømløst under baren (blød skygge i CSS)

    function open(item) {
      if (current === item) return;
      if (current) closeNow(current);
      hideSlider();   // det åbne punkt har sin egen gule knap-stil
      var top = headerBottom() + GAP;
      item.panel.style.top = top + 'px';
      item.panel.style.setProperty('--mtwTop', top + 'px');
      item.panel.hidden = false;
      item.btn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mtw-mn-open');
      current = item;
      scrollAtOpen = window.scrollY;
    }

    function closeNow(item) {
      item.panel.hidden = true;
      item.btn.setAttribute('aria-expanded', 'false');
      if (current === item) {
        current = null;
        document.body.classList.remove('mtw-mn-open');
      }
    }

    function closeAll() {
      if (timer) { clearTimeout(timer); timer = null; }
      if (current) closeNow(current);
    }

    function schedule(fn, ms) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(fn, ms);
    }

    nav.querySelectorAll('.mtw-mn-item').forEach(function (li) {
      var btn = li.querySelector('[data-mtw-mn-btn]');
      var panel = li.querySelector('[data-mtw-mn-panel]');
      if (!btn || !panel) return;
      var item = { li: li, btn: btn, panel: panel };
      items.push(item);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (current === item) closeAll();
        else { if (timer) clearTimeout(timer); open(item); }
      });

      btn.addEventListener('mouseenter', function () { if (!current) moveSlider(btn); });

      li.addEventListener('mouseenter', function () {
        schedule(function () { open(item); }, OPEN_DELAY);
      });
      li.addEventListener('mouseleave', function () {
        schedule(function () { if (current === item) closeNow(item); }, CLOSE_DELAY);
      });

      // Stagger-indeks til entrance-koreografien (CSS animation-delay)
      panel.querySelectorAll('[data-mtw-mn-pane]').forEach(function (p) {
        var els = p.querySelectorAll('.mtw-mn-chip, .mtw-mn-link');
        for (var i = 0; i < els.length; i++) els[i].style.setProperty('--i', Math.min(i, 18));
      });
      var bodyEls = panel.querySelectorAll('.mtw-mn-body--wall .mtw-mn-tile, .mtw-mn-body--mix .mtw-mn-tile, .mtw-mn-body--mix .mtw-mn-mcol h4, .mtw-mn-body--mix .mtw-mn-link');
      for (var bi = 0; bi < bodyEls.length; bi++) bodyEls[bi].style.setProperty('--i', Math.min(bi, 20));
      var rows = panel.querySelectorAll('.mtw-mn-row');
      for (var ri = 0; ri < rows.length; ri++) rows[ri].style.setProperty('--i', Math.min(ri, 14));

      // Faner i panelet
      var tabs = panel.querySelectorAll('[data-mtw-mn-tab]');
      var panes = panel.querySelectorAll('[data-mtw-mn-pane]');
      function activate(idx) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-mtw-mn-tab') === String(idx);
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panes.forEach(function (p) {
          var on = p.getAttribute('data-mtw-mn-pane') === String(idx);
          p.classList.toggle('is-active', on);
          p.hidden = !on;
        });
      }
      tabs.forEach(function (t) {
        var idx = t.getAttribute('data-mtw-mn-tab');
        t.addEventListener('mouseenter', function () { activate(idx); });
        t.addEventListener('click', function () { activate(idx); });
        t.addEventListener('keydown', function (e) {
          var n = parseInt(idx, 10);
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            var next = e.key === 'ArrowDown' ? n + 1 : n - 1;
            var target = panel.querySelector('[data-mtw-mn-tab="' + next + '"]');
            if (target) { target.focus(); activate(next); }
          }
        });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) {
        var btn = current.btn;
        closeAll();
        btn.focus();
      }
    });
    document.addEventListener('click', function (e) {
      if (current && !current.li.contains(e.target)) closeAll();
    });
    var scrollAtOpen = 0;
    window.addEventListener('scroll', function () {
      if (current && Math.abs(window.scrollY - scrollAtOpen) > 40) closeAll();
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (current) {
        var top = headerBottom() + GAP;
        current.panel.style.top = top + 'px';
        current.panel.style.setProperty('--mtwTop', top + 'px');
      }
    });

    // Luk når fokus forlader menuen (tab-navigation)
    nav.addEventListener('focusout', function () {
      requestAnimationFrame(function () {
        if (current && !current.li.contains(document.activeElement)) closeAll();
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* Mobilmenuen: skallen (søgning, Mine samlinger, Sælg, Hot Buy, Værditjek, konto) står i HTML'en, resten hentes fra
   sections/mtw-mobilmenu.liquid. Hentes ved idle på mobil og senest ved touch/klik på burgeren; sættes først ind i DOM'en,
   når kunden rører burgeren, så siden ikke bærer ~2.000 elementer, kunden måske aldrig ser. Indsættelsen i touchstart er målt
   til ~10 ms ved 390 px/CPU 4x og hakker ikke i trykket. Svaret er ens for alle og gemmes i sessionStorage, så næste side
   ikke henter igen. Under hentningen viser rækkerne de samme overskrifter, ved fejl er de almindelige links.
   Når indholdet er indsat, sendes mtw:mobilmenu-klar på document (mtw-mtg-nav.js lytter). */
(function () {
  if (window.__mtwMobilmenu) return;
  window.__mtwMobilmenu = 1;

  var SEKTION = 'mtw-mobilmenu', TTL = 30 * 60 * 1000, VENT_MAX = 6000;

  function init() {
    var liste = document.querySelector('[data-mtw-mm-liste]');
    var burger = document.querySelector('[data-mobile-menu]');
    if (!liste || !burger || !window.fetch) return;   // uden fetch bliver rækkerne almindelige links

    var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var NOEGLE = 'mtw_mm_v1_' + ((window.Shopify && Shopify.theme && Shopify.theme.id) || '');
    var html = null, henter = false, indsat = false, oensket = false, vagt = null;

    liste.setAttribute('aria-busy', 'true');

    function fraCache() {
      try {
        var v = sessionStorage.getItem(NOEGLE);
        if (!v) return null;
        var i = v.indexOf('|');
        return Date.now() - Number(v.slice(0, i)) < TTL ? v.slice(i + 1) : null;
      } catch (e) { return null; }
    }
    function tilCache(t) {
      try { sessionStorage.setItem(NOEGLE, Date.now() + '|' + t); } catch (e) {}
    }

    function visLinks() { liste.removeAttribute('aria-busy'); }

    /* Billederne ligger i lukkede akkordeoner. Indsatte loading="lazy" loader ikke på storefronten, så de får først src,
       når deres akkordeon åbnes og ingen forælder er skjult (Magic-vælgerens ruder). */
    function visBilleder() {
      var b = liste.querySelectorAll('img[data-mtw-src]');
      for (var i = 0; i < b.length; i++) {
        if (b[i].closest('details:not([open]), [hidden]')) continue;
        b[i].src = b[i].getAttribute('data-mtw-src');
        b[i].removeAttribute('data-mtw-src');
      }
    }

    function indsaet() {
      if (indsat || !html) return;
      var t = document.createElement('template');
      t.innerHTML = html;
      var svar = t.content.querySelector('[data-mtw-mm-svar]');
      if (!svar) { html = null; visLinks(); return; }
      indsat = true;
      clearTimeout(vagt);

      var felter = svar.querySelectorAll('[data-mtw-mm-sealed]');
      for (var f = 0; f < felter.length; f++) {
        var kilde = document.querySelector('template[data-mtw-mm-sealed-kilde="' + felter[f].getAttribute('data-mtw-mm-sealed') + '"]');
        if (kilde) felter[f].appendChild(kilde.content.cloneNode(true));
      }
      var billeder = svar.querySelectorAll('img');
      for (var b = 0; b < billeder.length; b++) {
        billeder[b].setAttribute('data-mtw-src', billeder[b].getAttribute('src'));
        billeder[b].removeAttribute('src');
        billeder[b].removeAttribute('loading');
      }

      var vent = liste.querySelectorAll('[data-mtw-mm-vent]');
      var ind = document.createDocumentFragment();
      while (svar.firstChild) ind.appendChild(svar.firstChild);
      liste.insertBefore(ind, vent[0] || null);
      for (var v = 0; v < vent.length; v++) vent[v].parentNode.removeChild(vent[v]);
      liste.removeAttribute('aria-busy');

      liste.addEventListener('toggle', visBilleder, true);   // toggle bobler ikke, men kan fanges
      liste.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-mtg-mode]')) visBilleder();
      });
      document.dispatchEvent(new CustomEvent('mtw:mobilmenu-klar', { detail: { liste: liste } }));
    }

    function hent() {
      if (html || henter || indsat) return;
      html = fraCache();
      if (html) return;
      henter = true;
      fetch(ROOT + '?section_id=' + SEKTION, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (t) {
          if (t.indexOf('data-mtw-mm-svar') < 0) throw new Error('tom');
          henter = false;
          html = t;
          tilCache(t);
          if (oensket) indsaet();
        })
        .catch(function () {
          henter = false;
          if (oensket) { clearTimeout(vagt); visLinks(); }
        });
    }

    /* Kunden er på vej ind i menuen: indsæt nu, eller så snart svaret er her. Et nyt forsøg efter en fejl kan stadig nå at erstatte linkene. */
    function brug() {
      if (indsat) return;
      oensket = true;
      hent();
      if (html) { indsaet(); return; }
      if (!vagt) vagt = setTimeout(visLinks, VENT_MAX);
    }

    burger.addEventListener('touchstart', brug, { passive: true });
    burger.addEventListener('mouseenter', brug);
    burger.addEventListener('click', brug);

    /* Forvarm ved idle, men kun hvor burgeren vises, og ikke hvis kunden sparer data. */
    function idle() {
      if (!burger.getBoundingClientRect().width) return;
      var net = navigator.connection;
      if (net && (net.saveData || /2g/.test(net.effectiveType || ''))) return;
      hent();
    }
    var forvarmet = false;
    function forvarm() {
      if (forvarmet) return;
      forvarmet = true;
      if (window.requestIdleCallback) requestIdleCallback(idle, { timeout: 4000 });
      else setTimeout(idle, 2000);
    }
    /* Efter load, men højst 3 s efter DOM'en: på langsomt net kan load tage 20 s, og kunden når at trykke før. */
    if (document.readyState === 'complete') forvarm();
    else {
      window.addEventListener('load', forvarm);
      setTimeout(forvarm, 3000);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
